export const PROMPT_TYPE_OPTIONS: { value: string; label: string }[] = [
  {
    value: "generate_executive_summary",
    label: "Generate Executive Summary",
  },
];

export interface PromptOverrideFormState {
  id?: string;
  promptType: string;
  content: string;
  model: string[];
  openRouterKeyId?: string;
}

export const INITIAL_FORM_STATE: PromptOverrideFormState = {
  promptType: "",
  content: "",
  model: [],
  openRouterKeyId: "",
};
